import { Outlet } from "react-router-dom";

export default function ModalBodyLayout() {
    return (
        <div className="modal-body">
            <Outlet />
        </div>
    );
}